"use client";

import Link from "@casino/client/components/Link";
import { Button, cn } from "@workspace/frontend-ui";

type Props = {
  link?: string;
  handle: string | undefined;
  text: string;
  isMobile: boolean;
};

const PromoButtonLink: FC<Props> = ({ link, handle, text, isMobile }) => (
  <Link href={link || `/promotions/${handle}`}>
    <Button
      size={isMobile ? "sm" : "default"}
      className={cn("font-normal", isMobile && "w-full")}
    >
      {text}
    </Button>
  </Link>
);

export default PromoButtonLink;
